module.exports = __webpack_public_path__ + "assets/img/_Novo Show Unit_Bathroom2_RGB_lr.7310e3d8.jpg";